export interface Logger {
	log( message: string, ...args: unknown[] ): void;
	warn( message: string, ...args: unknown[] ): void;
	error( message: string, ...args: unknown[] ): void;
}

export const nullLogger: Logger = {
	log: () => {},
	warn: () => {},
	error: () => {}
};
